import { useState } from 'react';
import { api } from '../api';
import { useAuth } from '../context/AuthContext';

const DISMISS_KEY = 'verify-email-banner-dismissed';

export function VerifyEmailBanner() {
  const { user, refreshUser } = useAuth();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISS_KEY) === '1',
  );
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');
  const [error, setError] = useState('');

  if (!user || user.emailVerified || dismissed) return null;

  const handleResend = async () => {
    setStatus('sending');
    setError('');
    try {
      const res = await api.sendVerificationEmail();
      if (res.alreadyVerified) {
        await refreshUser();
        return;
      }
      setStatus('sent');
    } catch (err: any) {
      setStatus('error');
      setError(err.message);
    }
  };

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  };

  return (
    <div className="verify-email-banner">
      <span>
        Verify your email ({user.email}) to keep your account secure.
        {status === 'sent' && ' Check your inbox — link sent.'}
        {status === 'error' && ` ${error}`}
      </span>
      <span className="verify-email-banner-actions">
        <button
          type="button"
          className="btn btn-sm"
          onClick={handleResend}
          disabled={status === 'sending' || status === 'sent'}
        >
          {status === 'sending' ? 'Sending…' : status === 'sent' ? 'Sent' : 'Resend email'}
        </button>
        <button type="button" className="btn btn-sm" onClick={handleDismiss} title="Dismiss">
          ✕
        </button>
      </span>
    </div>
  );
}
